import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { PaymentFailureBanner } from './PaymentFailureBanner'
import { ToastContainer } from '../common'
import { useUiStore } from '../../stores'

export function DashboardLayout() {
  const { isSidebarCollapsed } = useUiStore()

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <PaymentFailureBanner />
      <Sidebar />
      <main
        className={`
          pt-4 pb-8 px-4 sm:px-6 lg:px-8
          transition-all duration-300
          ${isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'}
        `}
      >
        <div className="max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
      <ToastContainer />
    </div>
  )
}
